import React from 'react';
import { Badge, Button, StatusDot } from '../../../../components/ui';
import { Panel, PanelHeader } from './PanelHeader.js';

export interface DecisionRow {
  id: string;
  question: string;
  context: string;
  kind?: 'approve' | 'choose' | 'freeform';
}

interface DecisionsPanelProps {
  decisions?: DecisionRow[];
  onOpenConversation?: () => void;
}

export const DecisionsPanel: React.FC<DecisionsPanelProps> = ({ decisions = [], onOpenConversation }) => (
  <Panel>
    <PanelHeader
      title="Decisions awaiting you"
      subtitle="Approvals and unresolved questions in linked project threads"
      right={
        decisions.length > 0 ? (
          <Badge variant="warning" icon={<StatusDot variant="warning" size="sm" />}>
            {decisions.length} pending
          </Badge>
        ) : null
      }
    />
    {decisions.length === 0 ? (
      <div className="px-4 py-6 text-center text-xs">
        <div className="text-sm text-body">No pending decisions.</div>
        <div className="mt-1 text-faint">Linked project-thread decisions will appear here.</div>
      </div>
    ) : (
      <ul className="divide-y divide-border">
        {decisions.map((d) => (
          <li key={d.id} className="flex flex-wrap items-start justify-between gap-3 px-4 py-3">
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium text-heading">{d.question}</div>
              <div className="mt-1 text-xs text-muted">{d.context}</div>
            </div>
            <div className="flex items-center gap-1.5">
              <Button size="sm" onClick={onOpenConversation} disabled={!onOpenConversation}>
                Open in conversation
              </Button>
            </div>
          </li>
        ))}
      </ul>
    )}
  </Panel>
);
